import { DefaultModal, DefaultModalProps } from '@frontend/components/mobile';
import { CommonMessage } from '@frontend/lang';
import { LuX } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

const ID = 'confirm-delete-modal';
export interface ConfirmDeleteModalProps extends DefaultModalProps {
    onSubmit: (save: boolean) => void;
}

const ConfirmDeleteModal = (props: ConfirmDeleteModalProps) => {
    return (
        <DefaultModal
            id={ID}
            handleClose={props.handleClose}
            show={props.show}
            type={props.type}>
            <div className='bg-background-surface m-4 flex h-fit flex-col items-center justify-center gap-5 rounded-3xl p-6'>
                <div className='text-foreground-default flex w-full flex-col items-center justify-start gap-2'>
                    <div className='flex w-full flex-row justify-between'>
                        <span className='text-xl font-semibold'>
                            <FormattedMessage
                                id='mobile.pudo.transaction.delete-title'
                                defaultMessage='Delete transaction'
                                description='Delete transaction title'
                            />
                        </span>
                        <LuX
                            className='size-6'
                            onClick={props.handleClose}
                        />
                    </div>

                    <p className='font-medium'>
                        <FormattedMessage
                            id='mobile.pudo.transaction.delete-confirmation'
                            defaultMessage='Are you sure you want to delete this transaction?'
                            description='Delete confirmation message'
                        />
                    </p>
                </div>
                <div className='inline-flex items-center justify-end gap-2 self-stretch'>
                    <button
                        id='no-delete-button'
                        onClick={() => props.onSubmit(false)}
                        className='outline-brand-primary bg-background-surface flex items-center justify-center rounded-xl px-4 py-3 font-medium outline-2 outline-offset-[-2px]'>
                        <div className='text-brand-primary justify-start text-base font-medium'>{CommonMessage.BUTTONS.NO}</div>
                    </button>
                    <button
                        id='delete-button'
                        onClick={() => props.onSubmit(true)}
                        className='bg-brand-primary text-background-surface flex items-center justify-center rounded-xl px-4 py-3 font-medium'>
                        {CommonMessage.BUTTONS.YES}
                    </button>
                </div>
            </div>
        </DefaultModal>
    );
};

export default ConfirmDeleteModal;
